import React from "react";
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { lang = "en" } = useParams(); // fallback to 'en'
  const { t } = useTranslation();

  return (
    <footer className="footer pt-5">
      <div className="container">
        <div className="row g-4">
          {/* Company Info */}
          <div className="col-lg-4 col-md-6">
            <h3 className="footer-title">{t("footer.logo")}</h3>
            <p className="mb-4">{t("footer.description")}</p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h3 className="footer-title">{t("footer.quick_links")}</h3>
            <ul className="footer-links">
              <li><Link to={`/${lang}`}>{t("header.home")}</Link></li>
              <li><Link to={`/${lang}/about`}>{t("header.about")}</Link></li>
              <li><Link to={`/${lang}/blog`}>{t("header.blog")}</Link></li>
              <li><Link to={`/${lang}/contact`}>{t("header.contact")}</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-lg-4 col-md-6">
            <h3 className="footer-title">{t("footer.newsletter_title")}</h3>
            <p className='mb-4'>{t("footer.newsletter_description")}</p>
            <form className="mb-4">
              <div className="input-group">
                <input
                  type="email"
                  className="form-control newsletter-input"
                  placeholder={t("footer.email_placeholder")}
                />
                <button className="btn btn-subscribe text-white" type="submit">
                  {t("footer.subscribe_button")}
                </button>
              </div>
            </form>
            <p className="small">{t("footer.privacy_note")}</p>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom mt-5">
        <div className="container">
          <div className="row py-3">
            {/* Add footer bottom text here if needed */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
